import * as React from "react";
import { Slider as ShadcnSlider } from "src/shadcn/components/slider";

const Slider = React.forwardRef<
  React.ElementRef<typeof ShadcnSlider>,
  React.ComponentProps<typeof ShadcnSlider>
>((props, ref) => <ShadcnSlider ref={ref} {...props} />);

Slider.displayName = "Slider";

export { Slider };
